import SliderBase from './base-slider';
class StBlogSliderHandler extends SliderBase {
  
}

export default ( $scope ) => {
	elementorFrontend.elementsHandler.addHandler( StBlogSliderHandler, { $element: $scope } );
};
